export function validateSceneRename(
  proposedName: string,
  previousName: string,
  existingNames: string[]
): { name: string; error: string | null } {
  const name = proposedName.trim();
  if (!name) return { name, error: "Scene name cannot be empty." };
  if (
    existingNames.some(
      (existingName) =>
        existingName !== previousName && existingName.trim() === name
    )
  ) {
    return { name, error: "This name already exists." };
  }
  return { name, error: null };
}
